import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'panel'];

  close() {
    this.buttonTarget.setAttribute('aria-expanded', 'false');
    this.panelTarget.hidden = true;
  }

  open() {
    this.buttonTarget.setAttribute('aria-expanded', 'true');
    this.panelTarget.hidden = false;

    this.dispatch('open');
  }

  outside(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close();
  }
}
